<div class="my-company-wrapper">
  <div class="row">
    <div class="col-12">
      <h3 translate>THE_COMPANY</h3>
    </div>
  </div>
  <div class="row" *ngIf="form; else loading" [formGroup]="form">
    <div class="col-12">
      <nav ngbNav #nav="ngbNav" class="nav-tabs">
        <ng-container ngbNavItem>
          <a (click)="selectedNavItem = 'information'" ngbNavLink translate>INFORMATION</a>
          <ng-template ngbNavContent>
            <div class="row">
              <div class="col-12 col-md-6">
                <lib-gung-text-input gungTranslate="COMPANY_NAME" formControlName="name"></lib-gung-text-input>
                <lib-gung-text-input gungTranslate="ADDRESS1" formControlName="address1"></lib-gung-text-input>
                <lib-gung-text-input gungTranslate="ADDRESS2" formControlName="address2"></lib-gung-text-input>
                <lib-gung-text-input gungTranslate="ZIP" formControlName="zipCode"></lib-gung-text-input>
                <lib-gung-text-input gungTranslate="CITY" formControlName="city"></lib-gung-text-input>
                <lib-gung-text-input gungTranslate="COUNTRY" formControlName="country"></lib-gung-text-input>
              </div>
              <div class="col-12 col-md-6">
                <lib-gung-text-input
                  gungTranslate="ORG_NUMBER"
                  formControlName="organizationNumber"
                ></lib-gung-text-input>
                <lib-gung-text-input gungTranslate="EMAIL_ADDRESS" formControlName="email"></lib-gung-text-input>
                <lib-gung-text-input gungTranslate="TELEPHONE" formControlName="telephone"></lib-gung-text-input>
                <lib-gung-text-input gungTranslate="WEBADDRESS" formControlName="webAddress"></lib-gung-text-input>
              </div>
            </div>
          </ng-template>
        </ng-container>
        <ng-container ngbNavItem>
          <a (click)="selectedNavItem = 'logo'" ngbNavLink translate>LOGO</a>
          <ng-template ngbNavContent>
            <div class="row">
              <div class="col-12">
                <h5 class="mt-2">
                  <span translate>FAVICON</span>
                </h5>
                <!-- Only allow .ico files, chrome does not seem to handle .png as favicons -->
                <ng-template
                  *ngTemplateOutlet="
                    uploadImage;
                    context: {
                      $implicit: objectFileImagePreview['favicon'],
                      imgTag: 'favicon',
                      inputAccept: '.ico'
                    }
                  "
                ></ng-template>
              </div>
              <div class="col-12">
                <h5 class="mt-2">
                  <span translate>CUSTOMIZE_NAVBAR_LOGO</span>
                </h5>
                <ng-template
                  *ngTemplateOutlet="
                    uploadImage;
                    context: {
                      $implicit: objectFileImagePreview['logo'],
                      imgTag: 'logo'
                    }
                  "
                ></ng-template>
              </div>
              <div class="col-12">
                <h5 class="mt-2">
                  <span translate>CUSTOMIZE_LOGIN_LOGO</span>
                </h5>
                <ng-template
                  *ngTemplateOutlet="
                    uploadImage;
                    context: {
                      $implicit: objectFileImagePreview['logoLogin'],
                      imgTag: 'logoLogin'
                    }
                  "
                ></ng-template>
              </div>
              <div class="col-12">
                <h5 class="mt-2">
                  <span translate>CUSTOMIZE_ORDER_CONFIRM_LOGO</span>
                </h5>
                <ng-template
                  *ngTemplateOutlet="
                    uploadImage;
                    context: {
                      $implicit: objectFileImagePreview['logoOrderConfirm'],
                      imgTag: 'logoOrderConfirm'
                    }
                  "
                ></ng-template>
              </div>
            </div>
          </ng-template>
        </ng-container>
        <ng-container ngbNavItem>
          <a (click)="selectedNavItem = 'footer'" ngbNavLink translate>FOOTER</a>
          <ng-template ngbNavContent>
            <lib-my-company-footer [company]="myCompany"></lib-my-company-footer>
          </ng-template>
        </ng-container>
        <ng-container ngbNavItem>
          <a (click)="selectedNavItem = 'theme'" ngbNavLink translate>THEME</a>
          <ng-template ngbNavContent>
            <div class="row" formGroupName="colors">
              <div class="col-12 col-md-4">
                <h3 translate>COLOR</h3>

                <div class="d-flex align-items-end">
                  <lib-gung-color-input gungTranslate="PRIMARY_COLOR" formControlName="primary"></lib-gung-color-input>
                </div>
                <div class="d-flex align-items-end">
                  <lib-gung-color-input gungTranslate="SECONDARY_COLOR" formControlName="secondary"></lib-gung-color-input>
                </div>
              </div>

              <div class="col-12 col-md-4">
                <h3 style="visibility: hidden" translate>COLOR</h3>

                <div class="d-flex align-items-end">
                  <lib-gung-color-input gungTranslate="HOVER_COLOR" formControlName="hover"></lib-gung-color-input>
                </div>
                <div class="d-flex align-items-end">
                  <lib-gung-color-input gungTranslate="CONTRASTING_COLOR" formControlName="contrasting"></lib-gung-color-input>
                </div>
              </div>

              <div class="col-12 col-md-4">
                <h3 style="visibility: hidden" translate>COLOR</h3>
                <div class="d-flex align-items-end">
                  <lib-gung-color-input gungTranslate="NAVBAR_COLOR" formControlName="navbarcolor"></lib-gung-color-input>
                </div>
                <div class="d-flex align-items-end">
                  <lib-gung-color-input gungTranslate="NAVBAR_FONT_COLOR" formControlName="navbarfontcolor"></lib-gung-color-input>
                </div>
                <div class="d-flex align-items-end">
                  <lib-gung-color-input gungTranslate="NAVBAR_FONT_HOVER_COLOR" formControlName="navbarfonthovercolor"></lib-gung-color-input>
                </div>
              </div>

              <div class="col-12 col-md-4">
                <!--
                Removed this since it looks like it does not work.
                If noone pings me about this in a few weeks time I'll most likely remove it completely.
                <div class="d-flex flex-column justify-content-end h-100">
                  <button type="button" (click)="setupCustomization()" style="max-width: 6rem;" class="btn btn-primary" translate>TEST</button>
                </div>
                -->
              </div>

              <div class="col-12">
                  <hr />
              </div>

              <div class="col-12">
                <div class="d-flex">
                  <h3 translate class="mt-1">LOGIN_BACKGROUND</h3>
                </div>
                <ng-template
                  *ngTemplateOutlet="
                    uploadImage;
                    context: {
                      $implicit: objectFileImagePreview['loginBackgroundImage'],
                      imgTag: 'loginBackgroundImage'
                    }
                  "
                ></ng-template>
              </div>
              <div class="col-12">
                <div class="d-flex">
                  <h3 translate class="mt-1">FONTS</h3>
                </div>
                <div class="row">
                  <div class="col-12 col-md-auto">
                    <span class="">WOFF2</span>
                    <lib-gung-input-file
                      accept=".woff2"
                      (onFileSelect)="onDropFont($event, 'WOFF2')" />
                  </div>
                  <div class="col-12 col-md">
                    <a href="https://cdn2.gung.io/{{objectFileFontsPreview['WOFF2']}}" target="_blank">{{objectFileFontsPreview['WOFF2']}}</a>
                    @if (objectFileFontsPreview['WOFF2'] || objectFileFonts['WOFF2']) {
                      <button type="button" class="btn btn-danger btn-sm ms-2" (click)="removeFont('WOFF2')">
                        <i class="fa-solid fa-trash-can"></i>
                      </button>
                    }
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-12 col-md-auto">
                    <span class="">WOFF</span>
                    <lib-gung-input-file
                      accept=".woff"
                      (onFileSelect)="onDropFont($event, 'WOFF')" />
                  </div>
                  <div class="col-12 col-md">
                    <a href="https://cdn2.gung.io/{{objectFileFontsPreview['WOFF']}}" target="_blank">{{objectFileFontsPreview['WOFF']}}</a>
                    @if (objectFileFontsPreview['WOFF'] || objectFileFonts['WOFF']) {
                      <button type="button" class="btn btn-danger btn-sm ms-2" (click)="removeFont('WOFF')">
                        <i class="fa-solid fa-trash-can"></i>
                      </button>
                    }
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-12 col-md-auto">
                    <span class="">TTF</span>
                    <lib-gung-input-file
                      accept=".ttf"
                      (onFileSelect)="onDropFont($event, 'TTF')" />
                  </div>
                  <div class="col-12 col-md">
                    <a href="https://cdn2.gung.io/{{objectFileFontsPreview['TTF']}}" target="_blank">{{objectFileFontsPreview['TTF']}}</a>
                    @if (objectFileFontsPreview['TTF'] || objectFileFonts['TTF']) {
                      <button type="button" class="btn btn-danger btn-sm ms-2" (click)="removeFont('TTF')">
                        <i class="fa-solid fa-trash-can"></i>
                      </button>
                    }
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </ng-container>

        <ng-container ngbNavItem>
          <a (click)="selectedNavItem = 'script'" ngbNavLink translate>SCRIPT</a>
          <ng-template ngbNavContent>
            <div class="row">
              <div class="col-12 col-md-6" formGroupName="extra">
                <h3 translate>SCRIPT</h3>
                <div formGroupName="customization">
                  <lib-gung-text-area-input
                    suppressLabel="true"
                    gungTranslate="INDEX_HEADER"
                    formControlName="indexHead"
                    rowsNumber="10"
                  >
                  </lib-gung-text-area-input>
                </div>
              </div>
            </div>
          </ng-template>
        </ng-container>

        <ng-container ngbNavItem>
          <a (click)="selectedNavItem = 'layout'" ngbNavLink translate>LAYOUT</a>
          <ng-template ngbNavContent>
            <lib-my-company-layout [company]="myCompany"></lib-my-company-layout>
          </ng-template>
        </ng-container>

        <ng-container ngbNavItem>
          <a (click)="selectedNavItem = 'navbar-banner'" ngbNavLink translate>NAVBAR_BANNER</a>
          <ng-template ngbNavContent>
            <div class="row" formGroupName="extra">
              <div class="col-12 col-sm-4" formGroupName="navbarBanner">
                <lib-gung-checkbox-input-horizontal gungTranslate="ENABLE" formControlName="enabled"/>
              </div>

              @if (form.get('extra.navbarBanner.enabled')?.value) {
                <div class="col-12" formGroupName="navbarBanner">
                  <h3 translate class="">BANNER</h3>

                  <div class="row">
                    <div class="col-12">
                      <lib-gung-text-input
                        gungTranslate="TEXT"
                        formControlName="text"
                      ></lib-gung-text-input>
                    </div>

                    <div class="col-12 col-md-6 mt-2">
                      <lib-gung-select-option-input
                        gungTranslate="TEXT_STYLE"
                        [optionsList]="textFormattingOptionList"
                        formControlName="textFormatting"
                        [showId]="false"
                      />
                    </div>

                    <div class="col-12 col-md-6 mt-2">
                      <lib-gung-select-option-input
                        gungTranslate="BANNER_HEIGHT"
                        [optionsList]="bannerHeightOptionList"
                        formControlName="bannerHeight"
                        [showId]="false"
                      />
                    </div>

                    <div class="col-12 col-md-6 mt-2">
                      <div class="d-flex align-items-end">
                        <lib-gung-color-input gungTranslate="BACKGROUND" formControlName="backgroundColor"></lib-gung-color-input>
                      </div>
                    </div>

                    <div class="col-12 col-md-6 mt-2">
                      <div class="d-flex align-items-end">
                        <lib-gung-color-input gungTranslate="TEXT_COLOR" formControlName="textColor"></lib-gung-color-input>
                      </div>
                    </div>

                    <div class="col-12 col-md-6 mt-2">
                      <lib-gung-checkbox-input-horizontal gungTranslate="CENTER_TEXT" formControlName="centerText"/>
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="d-flex">
                    <h3 translate class="mt-3">IMAGE</h3>
                  </div>
                  <ng-template
                    *ngTemplateOutlet="
                      uploadImage;
                      context: {
                        $implicit: objectFileImagePreview['extra.navbarBanner.navbarBannerImage'],
                        imgTag: 'extra.navbarBanner.navbarBannerImage'
                      }
                    "
                  ></ng-template>
                </div>
              }
            </div>
          </ng-template>
        </ng-container>
        <ng-container ngbNavItem>
          <a (click)="selectedNavItem = 'order-confirmation-extra'" ngbNavLink translate>ORDER_CONFIRMATION_EXTRA</a>
          <ng-template ngbNavContent>
            <div class="row" formGroupName="extra">
              <div class="col-12" formGroupName="orderConfirmationExtra">
                <div class="row">
                  <div class="col-12 col-md-6">
                    <h5 class="mt-2" translate>BILLING_ADDRESS</h5>
                    <lib-gung-text-input gungTranslate="BILLING_ADDRESS_1" formControlName="billingAddress1"></lib-gung-text-input>
                    <lib-gung-text-input gungTranslate="BILLING_ADDRESS_2" formControlName="billingAddress2"></lib-gung-text-input>
                    <lib-gung-text-input gungTranslate="BILLING_ADDRESS_3" formControlName="billingAddress3"></lib-gung-text-input>
                    <h5 class="mt-2" translate>DELIVERY_ADDRESS</h5>
                    <lib-gung-text-input gungTranslate="DELIVERY_ADDRESS_1" formControlName="deliveryAddress1"></lib-gung-text-input>
                    <lib-gung-text-input gungTranslate="DELIVERY_ADDRESS_2" formControlName="deliveryAddress2"></lib-gung-text-input>
                    <lib-gung-text-input gungTranslate="DELIVERY_ADDRESS_3" formControlName="deliveryAddress3"></lib-gung-text-input>
                  </div>
                  <div class="col-12 col-md-6">
                    <h5 class="mt-2" translate>EXTRA_INFORMATION</h5>
                    <lib-gung-text-input gungTranslate="BANK_TRANSFER" formControlName="bankTransfer"></lib-gung-text-input>
                    <lib-gung-text-input gungTranslate="COMPANY_SEATING" formControlName="companySeating"></lib-gung-text-input>
                    <lib-gung-text-input gungTranslate="NUMBER_VAT" formControlName="numberVat"></lib-gung-text-input>
                    <lib-gung-text-input gungTranslate="TEXT_EXTRA" formControlName="textExtra"></lib-gung-text-input>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </ng-container>
      </nav>

      <div [ngbNavOutlet]="nav" class="mt-2"></div>
    </div>
  </div>
  <div class="row">
    <div class="col-12 text-right" *ngIf="shouldDisplayButtons()">
      <button type="button" class="btn btn-secondary" (click)="initForm()" translate>RESET</button>
      <button type="button" class="btn btn-primary" (click)="save()" translate>SAVE</button>
    </div>
  </div>
</div>

<ng-template #loading> LOADING <i class="fas fa-spinner fa-spin ml-2"></i></ng-template>

<ng-template #uploadImage let-fileImagePrev let-imgTag="imgTag" let-inputAccept="inputAccept">
  <div class="row">
    <div class="col-12 col-md-6 col-lg-4 my-3">
      @if (backendVersion402) {
        <lib-gung-input-file
          [accept]="inputAccept || 'image/*,video/mp4,video/webm,video/ogg,application/pdf'"
          multiple="true"
          enableDragDrop="true"
          (onFileSelect)="onDrop($event, imgTag)" />
      } @else {
        <lib-gung-input-file
          [accept]="inputAccept || 'image/*,application/pdf'"
          multiple="true"
          enableDragDrop="true"
          (onFileSelect)="onDrop($event, imgTag)" />
      }

    </div>
    <div class="col-12 col-md-6 col-lg-8">
      <div *ngIf="fileImagePrev" class="position-relative text-center">
        @if (imgTag === 'extra.navbarBanner.navbarBannerImage') {
          <button
            type="button"
            class="btn btn-danger btn-sm position-absolute"
            style="top: 0; right: 0; z-index: 2;"
            (click)="removeImage(imgTag)"
            translate
          >
            REMOVE_IMAGE
          </button>
        }

        @if (fileImagePrev.extra?.type === 'video') {
          <video width="100%" style="max-height: 300px;" controls autoplay muted loop>
            <source [src]="fileImagePrev.s3Uri" type="video/mp4" />
            Your browser doesn't support video.
          </video>
        } @else if (fileImagePrev.s3Uri?.toLowerCase().endsWith('.mp4') || fileImagePrev.s3Uri?.toLowerCase().endsWith('.webm') || fileImagePrev.s3Uri?.toLowerCase().endsWith('.ogg')) {
          <video width="100%" style="max-height: 300px;" controls autoplay muted loop>
            <source [src]="'https://cdn2.gung.io/' + fileImagePrev.s3Uri" type="video/mp4" />
            Your browser doesn't support video.
          </video>
        } @else if (fileImagePrev.s3ETag && fileImagePrev.s3Uri.endsWith('.ico')) {
          <img class="img-fluid" style="max-height: 150px;"
            [src]="'https://cdn2.gung.io/' + fileImagePrev.s3Uri + '?etag=' + fileImagePrev.s3ETag"
            alt="{{ fileImagePrev.description }}" />
        } @else if (fileImagePrev.s3ETag) {
          <img class="img-fluid" style="max-height: 150px;"
            [src]="fileImagePrev.s3Uri | gungImageUrl : 'etag:' + fileImagePrev.s3ETag : 'type:thumbnail' : 'size:800x500'"
            alt="{{ fileImagePrev.description }}" />
        } @else if (fileImagePrev.s3Uri) {
          <img class="img-fluid" style="max-height: 150px;" [src]="fileImagePrev.s3Uri" alt="{{ fileImagePrev.name }}" />
        }
      </div>
    </div>
  </div>
</ng-template>
